import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Avatar, darken, DialogContent, Typography } from '@mui/material';

export const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ProductTitle = styled(Typography)`
  font-weight: 600;
`;

export const ProductDescription = styled(Typography)`
  color: ${p => p.theme.palette.text.secondary};
`;

export const ProductPrice = styled(Typography)`
  font-weight: 600;
`;

export const ProductLogo = styled(Avatar)`
  --product-logo-size: 6rem;

  width: var(--product-logo-size);
  height: var(--product-logo-size);
  font-size: 4rem;

  ${p =>
    p.color &&
    css`
      background-color: ${darken(p.color!, 0.25)};
      color: ${p.theme.palette.getContrastText(p.color)};
    `}

  img {
    object-fit: contain;
  }
`;

ProductLogo.defaultProps = {
  variant: 'rounded',
};
